<template>
  <a href="https://wa.me/5491139198027" class="whatsapp-widget" target="_blank">
    <i class="fa fa-whatsapp whatsapp-widget__button"></i>
  </a>
</template>

<script>
export default {
  name: "WhatsappWidget"
};
</script>

<style>
.whatsapp-widget {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff !important;
  border-radius: 50px;
  text-align: center;
  font-size: 38px;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%),
    0 1px 5px 0 rgb(0 0 0 / 20%);
  z-index: 100;
}

.whatsapp-widget__button {
  margin-top: 10px;
}

@media (max-width: 767px) {
  .whatsapp-widget {
    bottom: 15px;
    right: 15px;
    width: 45px;
    height: 45px;
    font-size: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/WhatsappWidget.vue